import { render, staticRenderFns } from "./ItemSummary.vue?vue&type=template&id=0f1b5751&"
import script from "./ItemSummary.vue?vue&type=script&lang=ts&"
export * from "./ItemSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports